import React from 'react';
import { TextField, Button, Box } from '@mui/material';

const ViewGanancias = React.memo(({ ganancias, onClose }: any) => {
  return (
    <div>
      <form>
        <TextField label='Fecha' value={ganancias.GanRe_Fecha} fullWidth disabled sx={{ marginBottom: '0.8rem', marginTop: '1rem' }} size='small' />
        <TextField label='Producto' value={ganancias.Pr_Nombre} fullWidth disabled sx={{ marginBottom: '0.8rem' }} size='small' />
        <TextField label='Subtotal' value={ganancias.GanRe_Sub1} fullWidth disabled sx={{ marginBottom: '0.8rem' }} size='small' />
        <TextField label='Iva' value={ganancias.GanRe_Iva1} fullWidth disabled sx={{ marginBottom: '0.8rem' }} size='small' />
        <TextField label='Total' value={ganancias.GanRe_Total1} fullWidth disabled sx={{ marginBottom: '0.8rem' }} size='small' />
        <TextField label='Mano de Obra' value={ganancias.GanRe_ManoObra} fullWidth disabled sx={{ marginBottom: '0.8rem' }} size='small' />
        <TextField label='Gasto adicional' value={ganancias.GanRe_GastoAdicional} fullWidth disabled sx={{ marginBottom: '0.8rem' }} size='small' />
        <TextField label='Porcentaje de utilidad' value={ganancias.GanRe_PorceUtilidad} fullWidth disabled sx={{ marginBottom: '0.8rem' }} size='small' />
        <TextField label='Utilidad' value={ganancias.GanRe_Utilidad} fullWidth disabled sx={{ marginBottom: '0.8rem' }} size='small' />
        <TextField label='Subtotal' value={ganancias.GanRe_SubTotal2} fullWidth disabled sx={{ marginBottom: '0.8rem' }} size='small' />
        <TextField label='Iva' value={ganancias.GanRe_Iva2} fullWidth disabled sx={{ marginBottom: '0.8rem' }} size='small' />
        <TextField label='Total' value={ganancias.GanRe_Total} fullWidth disabled sx={{ marginBottom: '0.8rem' }} size='small' />
        <TextField label='Tipo de cliente' value={ganancias.GanRe_TipoCliente === 1 ? 'Concesionario' : ganancias.GanRe_TipoCliente === 2 ? 'Particular' : 'Desconocido'} fullWidth disabled sx={{ marginBottom: '0.8rem' }} size='small' />
        <Box display='flex' justifyContent='flex-end'>
          <Button onClick={onClose} variant='outlined' color='error' size='small'>
            Cerrar
          </Button>
        </Box>
      </form>
    </div>
  );
});

export default ViewGanancias;
